export default __webpack_public_path__ + "static/media/full-screen-image-1.231907d3.jpg";